import React from 'react';
import { Route, Switch } from 'react-router-dom';

import PasswordResetRequest from './PasswordResetRequest';
import ResetPassword from './ResetPassword';

export default function PasswordReset() {
  return (
    <Switch>
      <Route path="/password/reset/:token" component={ResetPassword} />
      <Route path="/password/reset" component={PasswordResetRequest} />
    </Switch>
  );
}
